import React, { FC } from 'react';
import { useStyletron } from 'baseui';

type ButtonProps = {
  active?: boolean;
  disabled?: boolean;
  Icon?: any;
  text?: string;
  title: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  bold?: boolean;
};

const Button: FC<ButtonProps> = ({
  active,
  disabled,
  Icon,
  text,
  title,
  type: buttonType = 'button',
  onClick = () => {},
  bold,
}) => {
  const [css, theme] = useStyletron();
  return (
    <button
      type={buttonType}
      onClick={() => onClick()}
      className={css({
        display: 'flex',
        alignItems: 'center',
        color:
          (disabled && theme.colors.mono700) ||
          (active ? theme.colors.primary : theme.colors.mono700),
        lineHeight: '1.375rem',
        fontWeight: bold ? 'bold' : 'normal',
        fontSize: '0.875rem',
        cursor: disabled ? 'default' : 'pointer',
        outline: '0',
        borderWidth: '0',
        backgroundColor: 'transparent',
        padding: '0',
        textDecoration: 'none',
        ':hover': {
          color: theme.colors.primary700,
          outline: '0',
          textDecoration: 'none',
        },
        ':focus': {
          color: theme.colors.primary700,
          outline: '0',
          textDecoration: 'none',
        },
        ':disabled': {
          cursor: 'default',
          color: theme.colors.mono700,
          textDecoration: 'none',
        },
        ':active': {
          textDecoration: 'none',
          ':disabled': {
            color: theme.colors.mono700,
          },
        },
      })}
      disabled={disabled}
      title={title}
    >
      {Icon && (
        <Icon
          size={18}
          title={title}
          className={css({ marginRight: theme.sizing.scale200 })}
        />
      )}
      {text}
    </button>
  );
};

export default Button;
